<template>
  <div
    @click="selectIcons"
    @keyup.enter="selectIcons"
    :class="{'ime-feature-icon col-xs-12 col-sm-6 col-md-6 col-lg-3 vz-button-link': true, 'col-12': twoOnMobile}"
    :data-loc="'Content:Button:Why this partnership:'+objC.subhead"
  >
    <div class="blackback">
      <div :class="{'fi-disabled': disabled, 'fi-active': !disabled}">
        <div class="icon-wrap">
          <img :src="objC.img" v-if="!objP.svg" />
          <div class="img-container" v-if="objP.svg" v-html="objC.img"></div>
        </div>
        <div class="divider-wrap">
          <img aria-hidden="true" alt="icon section divider" class="divider-sizing" :src="objP.divider" />
        </div>
        <div class="text-trigger">
          <span class="text-conceal"></span>
          <h6 v-html="objC.subhead" v-if="objP.seeTitle"></h6>
          <div class="ft-btn">
            <span v-if="closed">
              <img alt="reveal" class="show-icon-info" :src="objP.plus" />
            </span>
            <span v-if="open">
              <img alt="hide" class="hide-icon-info" :src="objP.minus" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <transition name="slideDown">
      <div v-show="showContent" class="textTransition">
        <div class="icon-text" v-html="objC.caption"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FeatureIcon",
  data: function() {
    return {
      showContent: false,
      disabled: false,
      closed: true,
      open: false
    };
  },
  props: {
    obj: Object
    //  {
    // 		type: 'FeatureIcon',
    // 		variant: '',
    // 		classes: '',
    // 		transitions: {
    // 			aos: {
    // 				name: '',
    // 				delay: '',
    // 				duration: ''
    // 			},
    // 			gsap: {
    // 				components: [],
    // 				script: ''
    // 			}
    // 		},
    // 		presentation: {
    // 	    svg: Boolean, // whether the img is an svg or file path
    //      seeTitle: Boolean // whether the subhead is visible on load
    //      twoOnMobile: Boolean // whether icons take up full or 50% width on mobile
    // 		},
    // 		content: {
    //      name: String, // name of the group it is associated with, all will have the same name in a group
    //      idx: String, // an ID/independent identifier to be used in processClicks method
    //      img: String, // file path to the image/graphic or inline svg code
    //      subhead: String,
    //      caption: String,
    // 		}
    // 	}
  },
  methods: {
    selectIcons: function() {
      this.showContent = !this.showContent;
      this.open = true;
      this.closed = false;
      this.disabled = false;
      this.$root.$emit(
        "featureIcon_clicked",
        this.objC.name,
        this.objC.idx,
        this.showContent
      );
    },
    processClicks: function(name, idx, showContent) {
      const isName = name === this.objC.name;
      if (showContent && isName) {
        if (idx != this.objC.idx) {
          this.disabled = true;
          this.showContent = false;
          this.open = false;
          this.closed = true;
        } else {
          this.disabled = false;
          this.open = true;
          this.closed = false;
        }
      } else if (!showContent && isName) {
        this.showContent = false;
        this.disabled = false;
        this.open = false;
        this.closed = true;
      }
    }
  },
  computed: {
    objP() {
      return this.obj.presentation;
    },
    objC() {
      return this.obj.content;
    },
    twoOnMobile() {
      return this.objP.twoOnMobile;
    }
  },
  mounted: function() {
    this.$root.$on("featureIcon_clicked", (name, idx, showContent) => {
      this.processClicks(name, idx, showContent);
    });

    if (this.obj.transitions.gsap.script) {
      this.obj.transitions.gsap.script();
    }
  }
};
</script>

<style lang="scss" scoped>
.textTransition {
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  position: absolute;
  overflow: hidden;
  z-index: -1;
}

.slideDown-enter-active,
.slideDown-leave-active {
  transition: all 0.5s ease-out;
}

.slideDown-enter,
.slideDown-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}

.fi-disabled {
  opacity: 0.5;
  transition: opacity ease-in 1s;
}

.fi-active {
  opacity: 1;
  transition: opacity ease-in 1s;
}

.blackback {
  background: $black;
  z-index: 99;
}

.ime-feature-icon {
  margin-bottom: 30px;
  text-align: center;
  user-select: none;
  opacity: 1;
  transition: opacity ease-in 1s;

  &:hover {
    cursor: pointer;
  }
  img,
  svg {
    cursor: pointer;
    max-width: 100%;
  }

  .fi-disabled {
    opacity: 0.5;
  }
  
  .icon-wrap {
    height: 60px;
    align-items: flex-end;
    display: flex;
  }
  .ft-btn {
    cursor: pointer;
    display: inline-block;
    line-height: 0;
  }
  .text-trigger {
    min-width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .text-trigger h6 {
    margin-bottom: 0 !important;
  }
  .text-conceal {
    height: 30%;
    width: 100%;
    position: absolute;
    z-index: 11;
    background-color: black;
    right: 0;

    @media screen and (max-width: 767px) {
      top: 96px;
    }
  }
  .divider-sizing {
    min-width: 340px;

    @media screen and (min-width: 400px) and (max-width: 575px) {
      width: 100%;
      position: relative;
    }
  }
  .divider-wrap {
    overflow: hidden;
    width: 1px;
    min-height: 20px;
    display: inline-flex;
    display: -webkit-inline-flex;
    visibility: hidden;
    margin-top: 20px;

    @media screen and (min-width: 400px) and (max-width: 575px) {
      display: block;
    }
  }
}

.icon-text {
  background: rgba(0, 0, 0, 0.5);
  padding-top: 10px;
}
</style>